import React from "react";
import Isvg from "../../../../../vendor/react-inlinesvg";
import { VstDropdown } from "vstui";
import AccessibleSearchResults from "../../../accessability/accessibleSearchResults";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.sortAZ = this.props.onSelect.bind(this, "az");
    this.sortZA = this.props.onSelect.bind(this, "za");
  }

  _target() {
    return (
      <button
        aria-expanded={this.state.menuOpen}
        id="toggle-figures-sort"
        className="noButton"
      >
        <span className="offScreen">{i18n.t("sorting.sort-by")}</span>
        <Isvg src="/img/filter.svg" />
      </button>
    );
  }

  _renderFilterButton() {
    if (this.props.count > 0) {
      return (
        <VstDropdown
          className="figures-dropdown"
          horizontal="right"
          headerTitle={i18n.t("reader.panels.figures")}
          isMobile={Fraction.Helpers.isSmallScreen()}
          target={this._target()}
          onOpen={() => this.setState({ menuOpen: true })}
          onClose={() => this.setState({ menuOpen: false })}
        >
          <VstDropdown.Item role="subheader">
            {i18n.t("sorting.sort-by")}
          </VstDropdown.Item>
          <VstDropdown.Item
            className={this.props.sortOrder === "az" ? "selected" : ""}
            onClick={this.sortAZ}
            selected={this.props.sortOrder === "az"}
          >
            {i18n.t("sorting.book-order-az")}
          </VstDropdown.Item>
          <VstDropdown.Item
            className={this.props.sortOrder === "za" ? "selected" : ""}
            onClick={this.sortZA}
            selected={this.props.sortOrder === "za"}
          >
            {i18n.t("sorting.book-order-za")}
          </VstDropdown.Item>
        </VstDropdown>
      );
    }
  }

  render() {
    const count = this.props.count
      ? `${this.props.count} ${i18n.t("reader.panels.figures")}`
      : i18n.t("reader.figures.no-results");

    return (
      <div className="figures-sort-filter-bar">
        <AccessibleSearchResults className="result" result={count}/>
        {this._renderFilterButton()}
      </div>
    );
  }
}
